import { useQuery } from "@tanstack/react-query";
import { getForms } from "../services/get-active-form";

export function useForms() {
  return useQuery({
    queryKey: ["forms"],
    queryFn: () => getForms(),
  });
}
